import { useAuth } from "@/core/hooks/useAuth";
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getProtectedRedirect } from "@/core/auth/routeGuards";

const ProtectedRoute: React.FC = () => {
  const { isLoggedIn, user } = useAuth();
  const location = useLocation();

  const redirectTo = getProtectedRedirect(isLoggedIn, user, location.pathname);

  if (redirectTo) {
    return (
      <Navigate
        to={redirectTo}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
